import React, { useState, useEffect } from 'react';
import { getFocusHistory } from '../../services/OrdersService';
import { processError } from '../../services/ServiceUtils';

function ActionBadge({ action }) {
    return action === 'ENTER'
        ? <span className="badge bg-success py-1 px-2">Entrou no foco</span>
        : <span className="badge bg-secondary py-1 px-2">Saiu do foco</span>;
}

/**
 * Histórico de trocas de moeda-alvo do auto mode. Só aparece quando há registros —
 * e só há registros quando o ranking influenciou a operação (modo automático com
 * automações coringa). Estratégias de um único ativo não geram histórico de foco.
 */
const PAGE_SIZE = 10;

function FocusHistory({ startDate, endDate }) {
    const [rows, setRows] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const [page, setPage] = useState(0);

    useEffect(() => {
        if (!startDate || !endDate) return;
        setLoading(true);
        getFocusHistory(startDate, endDate)
            .then(data => { setRows(data || []); setPage(0); setLoading(false); })
            .catch(err  => { setError(processError(err)); setLoading(false); });
    }, [startDate, endDate]);

    if (loading) return null;
    if (error || !rows.length) return null;

    const pageCount = Math.ceil(rows.length / PAGE_SIZE);
    const paged = rows.slice(page * PAGE_SIZE, (page + 1) * PAGE_SIZE);

    return (
        <div className="card card-body border-0 shadow mt-4">
            <h5 className="mb-1">Histórico de Moeda-Alvo (auto mode) <span className="text-muted" style={{ fontSize: '0.7em' }}>({rows.length})</span></h5>
            <p className="text-muted small mb-3">
                Quando o ranking do scanner colocou ou tirou um ativo da operação automática.
            </p>
            <div className="table-responsive">
                <table className="table table-hover table-sm mb-0">
                    <thead>
                        <tr className="align-middle">
                            <th>Data/Hora</th>
                            <th>Símbolo</th>
                            <th>Evento</th>
                            <th>Rank</th>
                            <th>Cenário</th>
                        </tr>
                    </thead>
                    <tbody>
                        {paged.map(r => (
                            <tr key={r.id}>
                                <td className="text-nowrap"><small>{new Date(r.createdAt).toLocaleString()}</small></td>
                                <td><strong>{r.symbol}</strong></td>
                                <td><ActionBadge action={r.action} /></td>
                                <td>{r.rank != null ? `#${r.rank}` : <span className="text-muted">—</span>}</td>
                                <td>{r.marketOutlook ? <small className="text-muted">{r.marketOutlook}</small> : <span className="text-muted">—</span>}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            {pageCount > 1 && (
                <div className="d-flex justify-content-between align-items-center mt-2">
                    <button className="btn btn-sm btn-outline-secondary" disabled={page === 0} onClick={() => setPage(p => Math.max(0, p - 1))}>← Anterior</button>
                    <small className="text-muted">Página {page + 1} de {pageCount}</small>
                    <button className="btn btn-sm btn-outline-secondary" disabled={page >= pageCount - 1} onClick={() => setPage(p => Math.min(pageCount - 1, p + 1))}>Próxima →</button>
                </div>
            )}
        </div>
    );
}

export default FocusHistory;
